import ContactSupportIcon from 'assets/images/contact-support-icon.svg';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

function ContactSupportButton(): JSX.Element {
  return (
    <>
      <Tooltip
        id="contact-support-tooltip"
        content="Need help?"
        className="bg-gray-900 text-white w-fit rounded px-2 py-1 text-sm"
      />
      <a
        href="https://share.hsforms.com/1eUcxWC74TGqLD26ITeJzpw5n98c"
        target="_blank"
        rel="noreferrer"
        data-tooltip-id="contact-support-tooltip"
        data-tooltip-offset={6}
        data-tooltip-position-strategy="fixed"
        className="cursor-pointer fixed bottom-4 right-4 drop-shadow-md">
        <img src={ContactSupportIcon} />
      </a>
    </>
  );
}

export default ContactSupportButton;
